<div class="register">
  <div class="register__header">
    <h2 class="register__header__title">Register to KEYS<span>7</span></h2>
    <div class="register__header__link">
      <span>Already have an account?</span>
      <a routerLink="/login"> Login</a>
    </div>
  </div>

  <div class="register__qr">
    <p class="register__qr-text">Continue with your phone.</p>
    <img
      class="register__qr-code"
      src="/assets/images/register/QR_code.png"
      alt="QR Code"
    />
  </div>

  <nz-divider nzText="or" class="register__divider"></nz-divider>

  <div class="register__social-buttons">
    <!-- Discord -->
    <app-discord-signin
      (buttonClick)="registerClick()"
      text="Register with Discord"
      [pluginName]="pluginName"
      page="register"
    ></app-discord-signin>

    <!-- Microsoft -->
    <app-microsoft-signin
      (buttonClick)="registerClick()"
      (token)="onMicrosoftToken($event)"
      text="Register with Xbox"
      [pluginName]="pluginName"
    ></app-microsoft-signin>

    <!-- Google -->
    <app-google-signin
      (buttonClick)="registerClick()"
      (token)="onGoogleToken($event)"
      text="Register with Google"
      [pluginName]="pluginName"
    ></app-google-signin>

    <!-- Facebook -->
    <app-facebook-signin
      (buttonClick)="registerClick()"
      (token)="onFacebookToken($event)"
      text="Register with Facebook"
      [pluginName]="pluginName"
    ></app-facebook-signin>

    <!-- Apple -->
    <app-apple-signin
      (buttonClick)="registerClick()"
      (token)="onAppleToken($event)"
      text="Register with Apple"
      [pluginName]="pluginName"
      page="register"
    ></app-apple-signin>
  </div>

  <nz-divider nzText="or" class="register__divider"></nz-divider>

  <form
    nz-form
    [formGroup]="validateForm"
    (ngSubmit)="submitForm()"
    class="register__form"
    autocomplete="off"
  >
    <div class="register__form-item-row">
      <div class="register__form-item">
        <label class="register__label">First Name</label>
        <nz-input-group>
          <input
            nz-input
            nztype="primary"
            placeholder="Jhon"
            formControlName="firstName"
            class="register__input beta"
            [ngClass]="{
              'border-error':
                validateForm.controls['firstName'].invalid &&
                validateForm.controls['firstName'].touched,
            }"
          />
        </nz-input-group>
        <div
          *ngIf="
            validateForm.controls['firstName'].invalid &&
            validateForm.controls['firstName'].touched
          "
          class="register__form__error"
        >
          * Please enter your first name
        </div>
      </div>

      <div class="register__form-item">
        <label class="register__label">Last Name</label>
        <nz-input-group>
          <input
            nz-input
            nztype="primary"
            placeholder="Doe"
            formControlName="lastName"
            class="register__input beta"
            [ngClass]="{
              'border-error':
                validateForm.controls['lastName'].invalid &&
                validateForm.controls['lastName'].touched,
            }"
          />
        </nz-input-group>
        <div
          *ngIf="
            validateForm.controls['lastName'].invalid &&
            validateForm.controls['lastName'].touched
          "
          class="register__form__error"
        >
          * Please enter your last name
        </div>
      </div>
    </div>

    <div class="register__form-item">
      <label class="register__label">Email</label>
      <nz-input-group>
        <input
          nz-input
          nztype="primary"
          placeholder="example@gmail.com"
          formControlName="email"
          type="email"
          class="register__input beta"
          autocomplete="off"
          [ngClass]="{
            'border-error':
              validateForm.controls['email'].invalid &&
              validateForm.controls['email'].touched,
          }"
        />
      </nz-input-group>
      <div
        *ngIf="
          validateForm.controls['email'].invalid &&
          validateForm.controls['email'].touched
        "
        class="register__form__error"
      >
        * Please enter a valid email
      </div>
    </div>

    <div class="register__form-item">
      <label class="register__label">Password</label>
      <nz-input-group>
        <input
          nz-input
          nztype="primary"
          placeholder="********"
          formControlName="password"
          type="password"
          class="register__input beta"
          autocomplete="new-password"
          [ngClass]="{
            'border-error':
              validateForm.controls['password'].invalid &&
              validateForm.controls['password'].touched,
          }"
        />
      </nz-input-group>
      <div
        *ngIf="
          validateForm.controls['password'].invalid &&
          validateForm.controls['password'].touched
        "
        class="register__form__error"
      >
        * Password must be at least 8 characters long and contain a mix of
        letters and numbers
      </div>
    </div>

    <div class="register__form-item">
      <label class="register__label">Country</label>
      <nz-input-group>
        <nz-select
          nztype="primary"
          [formControl]="validateForm.controls.country"
          [nzCustomTemplate]="countryTemplate"
          class="register__country-select"
          nzPlaceHolder="Country"
          nzShowSearch
          [ngClass]="{
            'border-error':
              validateForm.controls['country'].invalid &&
              validateForm.controls['country'].touched,
          }"
        >
          <nz-option
            nzCustomContent
            *ngFor="let country of countryList"
            [nzValue]="country.code"
            [nzLabel]="country.name"
          >
            <div nz-flex nzAlign="center" nzGap="8px">
              <div [innerHTML]="country.flag" class="register__flag-icon"></div>
              <span>{{ country.name }}</span>
            </div>
          </nz-option>
        </nz-select>
      </nz-input-group>

      <div
        *ngIf="
          validateForm.controls['country'].invalid &&
          validateForm.controls['country'].touched
        "
        class="register__form__error"
      >
        * Country selection is required
      </div>
    </div>

    <div class="register__form-item-row">
      <div class="register__form-item">
        <label class="register__label">ZIP/Postal code</label>
        <nz-input-group>
          <input
            nztype="primary"
            nz-input
            placeholder="ZIP/Postal code"
            formControlName="zip"
            class="register__input beta"
            [ngClass]="{
              'border-error':
                validateForm.controls['zip'].invalid &&
                validateForm.controls['zip'].touched,
            }"
          />
        </nz-input-group>
        <div
          *ngIf="
            validateForm.controls['zip'].invalid &&
            validateForm.controls['zip'].touched
          "
          class="register__form__error"
        >
          * Please entery your ZIP/Postal code
        </div>
      </div>
      <div class="register__form-item">
        <label class="register__label">City</label>
        <nz-input-group>
          <input
            nztype="primary"
            nz-input
            placeholder="City"
            formControlName="city"
            class="register__input beta"
            [ngClass]="{
              'border-error':
                validateForm.controls['city'].invalid &&
                validateForm.controls['city'].touched,
            }"
          />
        </nz-input-group>
        <div
          *ngIf="
            validateForm.controls['city'].invalid &&
            validateForm.controls['city'].touched
          "
          class="register__form__error"
        >
          * Please enter your city
        </div>
      </div>
    </div>

    <div class="register__form-item">
      <label class="register__label">Address</label>
      <nz-input-group>
        <input
          nztype="primary"
          nz-input
          placeholder="Address"
          formControlName="address"
          class="register__input beta"
          [ngClass]="{
            'border-error':
              validateForm.controls['address'].invalid &&
              validateForm.controls['address'].touched,
          }"
        />
      </nz-input-group>
      <div
        *ngIf="
          validateForm.controls['address'].invalid &&
          validateForm.controls['address'].touched
        "
        class="register__form__error"
      >
        * Please enter your address
      </div>
    </div>

    <div class="register__form-item" *ngIf="validateForm.value.country">
      <label class="register__label">Phone</label>
      <div class="register__phone-input">
        <nz-select
          nztype="primary"
          [formControl]="validateForm.controls.countryCode"
          [nzCustomTemplate]="dialingCodeTemplate"
          class="register__dialcode-select"
          nzPlaceHolder="Dial Code"
          nzShowSearch
          [ngClass]="{
            'border-error':
              validateForm.controls['countryCode'].invalid &&
              validateForm.controls['countryCode'].touched,
          }"
        >
          <nz-option
            nzCustomContent
            *ngFor="let country of countryList"
            [nzValue]="country.code"
            [nzLabel]="country.dialingCode"
          >
            <div nz-flex nzAlign="center" nzGap="8px">
              <div [innerHTML]="country.flag" class="register__flag-icon"></div>
              <span>{{ country.dialingCode }}</span>
            </div>
          </nz-option>
        </nz-select>

        <nz-input-group>
          <input
            nztype="primary"
            nz-input
            [placeholder]="placeholder"
            formControlName="phone"
            class="register__input beta"
            [mask]="
              getPhoneMaskForCountry(
                validateForm.value.countryCode || validateForm.value.country
              )
            "
            [ngClass]="{
              'border-error':
                (validateForm.controls['phone'].invalid &&
                  validateForm.controls['phone'].touched &&
                  !validateForm.controls['phone'].hasError('invalidPhone')) ||
                (validateForm.controls['phone'].touched &&
                  validateForm.controls['phone'].hasError('invalidPhone')),
            }"
          />
        </nz-input-group>
      </div>
      <div
        *ngIf="
          validateForm.controls['countryCode'].invalid &&
          validateForm.controls['countryCode'].touched
        "
        class="register__form__error"
      >
        * Country selection is required
      </div>
      <div
        *ngIf="
          validateForm.controls['phone'].touched &&
          validateForm.controls['phone'].invalid &&
          !validateForm.controls['phone']?.hasError('invalidPhone')
        "
        class="register__form__error"
      >
        * Phone number is required
      </div>
      <div
        *ngIf="
          validateForm.controls['phone'].touched &&
          validateForm.controls['phone']?.hasError('invalidPhone')
        "
        class="register__form__error"
      >
        Invalid phone number for selected country code.
      </div>
    </div>

    <label class="register__checkbox">
      <label nz-checkbox> </label>
      Yes, I agree to the &nbsp;
      <a href="" class="terms-and-conditions-link"> Terms & Conditions </a
      >&nbsp; and &nbsp;
      <a href="" class="official-rules-link"> Official Rules </a>
    </label>
    <div
      *ngIf="
        validateForm.controls['eula'].invalid &&
        validateForm.controls['eula'].touched
      "
      class="register__form__error"
    >
      You must agree to the terms and conditions
    </div>

    <button nz-button nzType="primary" type="submit" class="register__submit">
      Register
    </button>
  </form>
</div>

<ng-template #countryTemplate let-selected>
  <div class="register__select-wrapper" *ngIf="selected.nzValue">
    <div
      [innerHTML]="getFlagByCode(selected.nzValue)"
      class="register__select-flag"
    ></div>
    <span>{{ getCountryNameByCode(selected.nzValue) }}</span>
  </div>
</ng-template>

<ng-template #dialingCodeTemplate let-selected>
  <div class="register__select-wrapper" *ngIf="selected.nzValue">
    <div
      [innerHTML]="getFlagByCode(selected.nzValue)"
      class="register__select-flag"
    ></div>
    <span>{{ getDialingCodeByCountryCode(selected.nzValue) }}</span>
  </div>
</ng-template>
